module.exports = __webpack_public_path__ + "img/stack05.dd9f0fdc.svg";